import { GetMentorFormServices } from "./service";
import { toast } from "react-toastify";


import { isLoading } from "../../../common/dependencies/action/action";
import swal from "sweetalert";

export const registerStartupCohort = (params) => async (dispatch) => {
  //
  dispatch(isLoading(true));
  return GetMentorFormServices.registerStartupCohort(params)
    .then((response) => {
      //
      if (response?.data?.success) {
        dispatch(isLoading(false));
        window.location.href = "/";
        swal(
          "Thank you",
          " Application Submitted Successfully." +
            " To View Your Application Status, Log In again.",
          "success",
          { closeOnClickOutside: false }
        );
        // toast.success(response?.data?.data);
        return true;
        
      } else {
        dispatch(isLoading(false));
       
        
        return false;
      }
    })
    .catch((error) => {

      // toast.error(INTERNAL_SERVER_ERROR);
      dispatch(isLoading(false));
      
    });
};

